import { render, staticRenderFns } from "./VehicleModification.vue?vue&type=template&id=5640339c&"
import script from "./VehicleModification.vue?vue&type=script&lang=js&"
export * from "./VehicleModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports